/**
 * SpeedRole - Role para conversão de unidades de velocidade
 *
 * Implementa os 4 pilares via SimpleRole base class.
 * Para uso funcional, prefira importar dos pilares diretamente.
 *
 * Nota: Velocidade pode ser negativa (movimento em direção oposta).
 *
 * @example
 * // OOP style
 * import { speedRole } from '@attrx/role-morphic/speed';
 * speedRole.convert('kilometer_per_hour', 'mile_per_hour', 100);  // 62.1371
 *
 * // Functional style (preferido)
 * import { convertSpeed } from '@attrx/role-morphic/speed/convert';
 * convertSpeed('kilometer_per_hour', 'mile_per_hour', 100);  // 62.1371
 */

import { SimpleRole } from "../../contracts";
import { SPEED_UNITS, SPEED_ALIASES } from "./constants";

// =============================================================================
// SPEED ROLE CLASS
// =============================================================================

export class SpeedRole extends SimpleRole {
  readonly name = "speed";
  readonly base = "meter_per_second";
  readonly units = SPEED_UNITS;
  readonly aliases = SPEED_ALIASES;

  // Speed pode ser negativo (movimento em direção oposta)
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da SpeedRole */
export const speedRole = new SpeedRole();
